import React, { Component } from 'react';
import { mapHttpToProps } from 'reducers';
import route from 'route';
import './styles.css';
//import GoogleTagManager from '../../components/GTM';
//import TagManager from 'react-gtm-module';

import Form from 'components/Form';

//const URLSearchParams = require('url-search-params');

const fields = [
	{
		key: 'nome',
		hint: 'Nome e Cognome',
		errorRequired: 'Indicare il nome del richiedente'
	},
	{
		key: 'telefono',
		hint: 'Telefono',
		rules: ['phone'],
		errorRequired: 'Indicare il telefono di contatto'
	}
];

const referenceForm = React.createRef();

class Home extends Component {
	componentDidMount() {
		// Global site tag (gtag.js) - Google Ads: 652852675
		let gScript = document.createElement('script');
		gScript.type = 'text/javascript';
		gScript.async = true;
		gScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-652852675';
		let g = document.getElementsByTagName('script')[0];
		g.parentNode.insertBefore(gScript, g);

		window.dataLayer = window.dataLayer || [];
		function gtag(){
			window.dataLayer.push(arguments);
		}

		gtag('js', new Date());
		gtag('config', 'AW-652852675');

		// const tagManagerArgs = {
		// 	dataLayer: {
		// 		js: new Date(),
		// 		config: 'AW-652852675',
		// 		page: 'home'
		// 	}
		// };
		// TagManager.dataLayer(tagManagerArgs);
	}

	render() {
		return (
			<div className="home">
				<Form
					ref={referenceForm}
					style={{ width: '100%', height: 'auto' }}
					fields={fields}
					onFinish={data => {
						if (!referenceForm.current.validateForm()) {
							return;
						}

						this.props.httpCall(
							'insertLead',
							{ ...data, idLanding: 80 },
							{
								then: res => {
									//const urlParams = new URLSearchParams(window.location.search);
									let j = null;
									if (res.orderID) {
										j = res.orderID;
									}
									this.props.history.push(
										route('thanks') + '?j=' + j
									);
								},
								catch: error => {
									alert(error);
								}
							}
						);
					}}
				/>

			</div>
		);
	}
}

export default mapHttpToProps(Home, ['insertLead']);



// WEBPACK FOOTER //
// ./src/screens/Home/index.js